import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=588ad1ea&scoped=true&"
import script from "./ErrorMessage.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ErrorMessage.vue?vue&type=style&index=0&id=588ad1ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588ad1ea",
  null
  
)

export default component.exports